export const excelMenu = [
  "SN_SAL_SAO_REG_001",
  "SN_MAS_BAS_REG_002",
  "SN_PRD_BAS_REG_004",
  "SN_PRD_BAS_REG_044",
  "SN_PRD_BAS_REG_014",
  "EXC000000000029003",
  "SN_SAL_SAO_REG_001_TEX",
  "SN_PUR_POR_REG_001",
  "SN_PMS_PJT_REG_004",
  "SN_SAL_BAS_REG_006",
  "SN_PRD_WRK_REG_002_TEX",
  "SN_QMS_BAS_REG_001",
  "SN_MAS_BAS_REG_001",
  "SN_MAS_ORG_REG_006",
  "SN_MAS_ORG_REG_004",
  "SN_SYS_AUT_REG_004",
  "SN_MTL_PTY_REG_001",
  "SN_MTL_MTR_REG_001_TEX",
  "SN_MTL_MTI_REG_001_TEX",
  "SN_PRD_BAS_REG_001_CHEM",
  "SN_PRD_BAS_REG_001_TEX",
  "SN_MTL_MTR_REG_001",
  "SN_MTL_MTI_REG_001",
  "SN_MTL_MTR_REG_002",
  "SN_MTL_MTI_REG_002",
  "SN_MAS_BAS_REG_001_TEX",
  "SN_SAL_BAS_REG_001",
  "SN_PUR_BAS_REG_002",
  "SN_SAL_BAS_REG_002",
  "SN_PUR_BAS_REG_003",
  "SN_SFA_EXPENSE_REG_001",
];
